import { DomainName } from "./Constants";

export const defaultIPAddress = "40.80.156.205";
export const defaultCountryCode = "US";
export const defaultCurrencyCode = "USD";

export const downloadCounter = 8;

// export const currentEnv =
//     process.env.REACT_APP_ENVIRONMENT === 'development'
//         ? 'DEVELOPMENT'
//         : process.env.REACT_APP_ENVIRONMENT === 'production'
//         ? 'PRODUCTION'
//         : process.env.REACT_APP_ENVIRONMENT === 'test'
//         ? 'QA'
//         : 'QA'
const currentEnv = `${process.env.REACT_APP_ENVIRONMENT}`;

export const appDomain = () => {
  const domain = currentDomain()?.toLowerCase();

  let url: Record<string, string>;

  switch (domain) {
    case DomainName.WORKSIMPLI:
      url = {
        // DEVELOPMENT: "https://test.worksimpli.com", // For development, use the local
        DEVELOPMENT: "http://localhost:3500",
        QA: "https://test.worksimpli.com",
        STAGING: "https://staging.worksimpli.com",
        PRODUCTION: "https://worksimpli.com",
      };
      break;

    case DomainName.LEGALSIMPLI:
      url = {
        DEVELOPMENT: "http://localhost:3500",
        QA: "##LSTemplate_BaseUrl##",
        STAGING: "https://staging.legalsimpli.com",
        PRODUCTION: "https://legalsimpli.com",
      };
      break;

    default:
      url = {
        DEVELOPMENT: "http://localhost:3500",
        QA: "##LSTemplate_BaseUrl##",
        STAGING: "https://staging.legalsimpli.com",
        PRODUCTION: "https://legalsimpli.com",
      };
      break;
  }

  return url[currentEnv];
};

export const getTenantId = () => {
  const domain = currentDomain()?.toLowerCase();

  let tenantId: Record<string, string>;

  switch (domain) {
    case DomainName.WORKSIMPLI:
      tenantId = {
        QA: "1BAE83A3-BFAA-4C89-99B1-6DD2130E2F55",
        PRODUCTION: "1BAE83A3-BFAA-4C89-99B1-6DD2130E2F55",
        STAGING: "1BAE83A3-BFAA-4C89-99B1-6DD2130E2F55",
        DEVELOPMENT: "1BAE83A3-BFAA-4C89-99B1-6DD2130E2F55",
      };
      break;

    case DomainName.LEGALSIMPLI:
      tenantId = {
        QA: "A21468BD-04E0-4131-9DC7-54B61FEE0670",
        PRODUCTION: "A21468BD-04E0-4131-9DC7-54B61FEE0670",
        STAGING: "A21468BD-04E0-4131-9DC7-54B61FEE0670",
        DEVELOPMENT: "A21468BD-04E0-4131-9DC7-54B61FEE0670",
      };
      break;

    default:
      tenantId = {
        QA: "A21468BD-04E0-4131-9DC7-54B61FEE0670",
        PRODUCTION: "A21468BD-04E0-4131-9DC7-54B61FEE0670",
        STAGING: "A21468BD-04E0-4131-9DC7-54B61FEE0670",
        DEVELOPMENT: "A21468BD-04E0-4131-9DC7-54B61FEE0670",
      };
      break;
  }
  return tenantId[currentEnv];
};

export const getTenantGroupId = () => {
  const domain = currentDomain()?.toLowerCase();

  let tenantGroupId: Record<string, string>;

  switch (domain) {
    case DomainName.WORKSIMPLI:
      tenantGroupId = {
        QA: "580C8B5A-DB83-4834-14EF-08D9501E735D",
        PRODUCTION: "9C7D9766-9EBF-47A4-94E6-3F1F50CD4B2F",
        STAGING: "9C7D9766-9EBF-47A4-94E6-3F1F50CD4B2F",
        DEVELOPMENT: "580C8B5A-DB83-4834-14EF-08D9501E735D",
      };
      break;

    case DomainName.LEGALSIMPLI:
      tenantGroupId = {
        QA: "580C8B5A-DB83-4834-14EF-08D9501E735D",
        PRODUCTION: "9C7D9766-9EBF-47A4-94E6-3F1F50CD4B2F",
        STAGING: "9C7D9766-9EBF-47A4-94E6-3F1F50CD4B2F",
        DEVELOPMENT: "580C8B5A-DB83-4834-14EF-08D9501E735D",
      };
      break;

    default:
      tenantGroupId = {
        QA: "580C8B5A-DB83-4834-14EF-08D9501E735D",
        PRODUCTION: "9C7D9766-9EBF-47A4-94E6-3F1F50CD4B2F",
        STAGING: "9C7D9766-9EBF-47A4-94E6-3F1F50CD4B2F",
        DEVELOPMENT: "580C8B5A-DB83-4834-14EF-08D9501E735D",
      };
      break;
  }
  return tenantGroupId[currentEnv];
};

export const blobSignature = () => {
  const blobSign: any = {
    QA: "?sv=2020-04-08&si=pdfsimpliuserstest&sr=c&sig=C5E6T6kNLW0pcWAW2l2KrY1pboKjZQh1IhO%2FP9iozO8%3D",
    PRODUCTION: "?sv=2017-04-17&si=pdfsimpliusers&sr=c&sig=tLI3WycMdpg2v5sTxxX1RVi22y9Hz6tI8eeyOriK%2BjE%3D",
    STAGING: "?sv=2017-04-17&si=pdfsimpliusers&sr=c&sig=tLI3WycMdpg2v5sTxxX1RVi22y9Hz6tI8eeyOriK%2BjE%3D",
    DEVELOPMENT: "?sv=2020-04-08&si=pdfsimpliuserstest&sr=c&sig=C5E6T6kNLW0pcWAW2l2KrY1pboKjZQh1IhO%2FP9iozO8%3D",
  };
  return blobSign[currentEnv];
};

export const getTokenExIframeJs = () => {
  const tokenExJS: any = {
    QA: `https://static-qa.worksimpli.io/cdn/sso-dashboard/token-iframe-script.js?v=${Date.now()}`,
    PRODUCTION: `https://static.worksimpli.io/cdn/sso-dashboard/token-iframe-script.js?v=${Date.now()}`,
    STAGING: `https://static.worksimpli.io/cdn/sso-dashboard/token-iframe-script.js?v=${Date.now()}`,
    DEVELOPMENT: `https://static-qa.worksimpli.io/cdn/sso-dashboard/token-iframe-script.js?v=${Date.now()}`,
  };
  return tokenExJS[currentEnv];
};

export const getStorageAccount = () => {
  const domain = currentDomain()?.toLowerCase();
  let storageAccount: any = {
    QA: `https://test.legalsimpli.com`,
    PRODUCTION: `https://legalsimpli.com`,
    STAGING: `https://staging.legalsimpli.com`,
    // DEVELOPMENT: `https://test.legalsimpli.com`, // For development, use the local
    DEVELOPMENT: `https://local.templatehtml.com`,
  };
  switch (domain) {
    case DomainName.WORKSIMPLI:
      storageAccount = {
        QA: `https://test.worksimpli.com`,
        PRODUCTION: `https://worksimpli.com`,
        STAGING: `https://staging.worksimpli.com`,
        // DEVELOPMENT: `https://test.legalsimpli.com`, // For development, use the local
        DEVELOPMENT: `https://local.templatehtml.com`,
      };
      break;
    default:
    case DomainName.LEGALSIMPLI:
      storageAccount = {
        QA: `https://test.legalsimpli.com`,
        PRODUCTION: `https://legalsimpli.com`,
        STAGING: `https://staging.legalsimpli.com`,
        // DEVELOPMENT: `https://test.legalsimpli.com`, // For development, use the local
        DEVELOPMENT: `https://local.templatehtml.com`,
      };
      break;
  }

  return storageAccount[currentEnv];
};

export const getFacebookClientId = () => {
  const lsFb_key = "725764382922248";
  const wsFb_key = "1256651319339467";
  let domain = currentDomain();
  switch (domain) {
    case DomainName.LEGALSIMPLI:
      return lsFb_key;
    case DomainName.WORKSIMPLI:
      return wsFb_key;
    default:
      return lsFb_key;
  }
};

export const getGoogleClientId = () => {
  const lsGoogle_key = "857841731210-2vab128a29c3vhspiqvt32a4ukf10oaa.apps.googleusercontent.com";
  const wsGoogle_key = "668986576337-i32d94pm2rkr0jb44njgn1q86bp7i968.apps.googleusercontent.com";
  let domain = currentDomain();
  switch (domain) {
    case DomainName.LEGALSIMPLI:
      return lsGoogle_key;
    case DomainName.WORKSIMPLI:
      return wsGoogle_key;
    default:
      return lsGoogle_key;
  }
};
export const hidePaypal = (currencyCD: any) => {
  let isHide = false;
  const currenciesToHide = "ZAR|TRY|MYR|SAR|AED";
  if (currenciesToHide.split("|").includes(currencyCD)) {
    isHide = true;
  }
  return isHide;
};
export const EnableHomeRenderFromBlob = () => {
  const HomeRenderFromBlob: any = {
    QA: true,
    PRODUCTION: true,
    STAGING: true,
    DEVELOPMENT: true,
  };
  return HomeRenderFromBlob[currentEnv];
};
export const getInitializationVector = () => {
  const ivKey: any = {
    QA: "2908290630030702",
    PRODUCTION: "2908290630030702",
    STAGING: "2908290630030702",
    DEVELOPMENT: "2908290630030702",
  };
  return ivKey[currentEnv];
};

export const isPaymentMSEnable = () => {
  const isPaymentMSEnable: any = {
    QA: true,
    PRODUCTION: true,
    STAGING: true,
    DEVELOPMENT: true,
  };
  return isPaymentMSEnable[currentEnv];
};

export const currentDomain = () => {
  let domainName = DomainName.WORKSIMPLI;
  const currentUrl = window.location.hostname;
  if (currentUrl.indexOf("worksimpli") > -1) {
    domainName = DomainName.WORKSIMPLI;
  } else if (currentUrl.indexOf("legalsimpli") > -1) {
    domainName = DomainName.LEGALSIMPLI;
  }
  if (currentUrl.indexOf("signsimpli") > -1) {
    domainName = DomainName.SIGNSIMPLI;
  } else if (currentUrl.indexOf("pdfsimpli") > -1) {
    domainName = DomainName.PDFSIMPLI;
  } else if (currentUrl.indexOf("resumebuild") > -1) {
    domainName = DomainName.RESUMEBUILD;
  }
  return domainName;
};
export const getLogoImagePath = () => {
  const domain = currentDomain()?.toLowerCase();
  const logoName = domain === DomainName.WORKSIMPLI ? "worksimpli-logo.svg" : "legalsimpli-logo.svg";

  return process.env.PUBLIC_URL + "/static/images/" + logoName;
};
export const IsSingleLoginAPPEnable = () => {
  const isLoginAPPEnable: any = {
    PRODUCTION: false,
    STAGING: false,
    QA: false,
    DEVELOPMENT: false,
  };
  return isLoginAPPEnable[currentEnv];
};

export const getCaptchaSitekeyForSignup = () => {
  const lsSite_key = "6LcHh70rAAAAAEOjGuTXxNuMn_6om-fSU9S2ysQy";
  return lsSite_key;
};
